import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import useAuth from "../../hooks/useAuth";

import { injectStyle } from "react-toastify/dist/inject-style";
import { ToastContainer, toast } from "react-toastify";

if (typeof window !== "undefined") {
  injectStyle();
}

const ProductDetails = () => {
  function notify() {
    toast.dark("Congrats! Your order is being processed");
  }

  const { id } = useParams();
  const [product, setProduct] = useState([]);
  useEffect(() => {
    fetch("https://young-hamlet-12954.herokuapp.com/products")
      .then((res) => res.json())
      .then((data) => setProduct(data));
  }, []);

  //find the exact lipstick
  const exactProduct = product.find((product) => product._id === id);
  // form
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { user } = useAuth();
  const onSubmit = (data) => {
    data.product = exactProduct?.name;
    data.status = "Pending";
    data.bookedBy = user?.email;
    console.log(data);
    fetch("https://young-hamlet-12954.herokuapp.com/manageAll", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => console.log("success"));
  };

  return (
    <div className="pb-5 products">
      <div className="container pt-4">
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="text-center ">
              <h2 className="fw-bold">{exactProduct?.name}</h2>
              <img
                src={exactProduct?.img}
                alt={exactProduct?.name}
                className="img-fluid"
                width="400"
                height="400"
              />
            </div>

            <h6 className="fw-bold text-center">
              Price: ${exactProduct?.price}
            </h6>
            <p className="md-fs-5">{exactProduct?.description}</p>
          </div>
          <div className="col-12 col-md-4 border border-1 rounded">
            <h4 className="mt-4">Book This Lipstick</h4>
            <br />
            <form onSubmit={handleSubmit(onSubmit)}>
              <input
                defaultValue={user.displayName}
                {...register("name")}
                className="form-control"
              />
              <br />
              <input
                defaultValue={user.email}
                {...register("email", { required: true })}
                className="form-control"
              />
              {errors.email && (
                <span className="error">This field is required</span>
              )}
              <br />
              <input
                placeholder="Address"
                defaultValue=""
                {...register("address")}
                className="form-control"
              />
              <br />
              <input
                placeholder="City"
                defaultValue=""
                {...register("city")}
                className="form-control"
              />
              <br />
              <input
                placeholder="Phone number"
                defaultValue=""
                className="form-control"
                {...register("phone")}
              />
              <br />
              {/* <input
                    {...register("date")}
                    type="date"
                    className="form-control"
                  />
                  <br /> */}
              <button
                className="btn btn-custom w-100"
                type="submit"
                onClick={notify}
                id="animate.css"
              >
                Place Order
              </button>
            </form>
            <ToastContainer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
